import { EXTERNAL_SHARE, SHAREABLE_LINK } from '@confluence/named-routes/entry-points/routes.ts';
import { expVal } from '@confluence/feature-experiments';

export const isExternalShareRequest = () => {
	if (expVal('shareable_links_m0', 'isEnabled', false)) {
		return (
			!!EXTERNAL_SHARE.match(window.location.pathname) ||
			!!SHAREABLE_LINK.match(window.location.pathname)
		);
	}
	return !!EXTERNAL_SHARE.match(window.location.pathname);
};
